import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { n_ai_speaking, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

const WaveformBar = ({ amplitude, index, barWidth, barMargin, waveformHeight }) => {
  const height =
    amplitude !== 0 ? (amplitude * (waveformHeight - barWidth) > 50 ? 50 : amplitude * (waveformHeight - barWidth)) : 1
  const x = index * (barWidth + barMargin)
  const y = ((1 - amplitude) * waveformHeight) / 2 < 0 ? 0 : ((1 - amplitude) * waveformHeight) / 2

  return (
    <rect
      x={x}
      y={y}
      width={barWidth}
      height={height + barWidth}
      fill={COLORS.PURPLE500}
      rx={barWidth / 2}
      ry={barWidth / 2}
    />
  )
}

const WaveForm = ({ waveformData }) => {
  const waveformHeight = 50
  const barWidth = 6
  const barMargin = 6

  // console.log('waveformData', waveformData)

  return (
    <div className="flex-1 flex items-center justify-center">
      <svg height={waveformHeight} width={waveformData.length * (barWidth + barMargin)}>
        {waveformData.map((amplitude, index) => (
          <WaveformBar
            key={index}
            amplitude={amplitude}
            index={index}
            barWidth={barWidth}
            barMargin={barMargin}
            waveformHeight={waveformHeight}
          />
        ))}
      </svg>
    </div>
  )
}

const WhisperRecognition = ({ handleCancel, handleStop, waitingTranscription, waveformData, isSpeaking }) => {
  const { t } = useTranslation()
  const [completeText, cancelText] = [n_ai_speaking.ai_session.btn5, n_common.btn_cancel].map((i) => t(i))

  return (
    <>
      {/* {!waitingTranscription && <SpeakingWaveform isSpeaking={isSpeaking} />} */}
      {!waitingTranscription && <WaveForm waveformData={waveformData} />}
      <div className="mt-[16px] flex itmes-center justify-center w-full relative">
        <DSButton onClick={handleCancel} type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.LG} className="flex-[0.3]">
          <div className="Body1-14BD">{cancelText}</div>
        </DSButton>
        <div className="w-[8px]" />
        <DSButton
          type={BUTTON_TYPE.SOLID}
          size={BUTTON_SIZE.LG}
          onClick={handleStop}
          isLoading={waitingTranscription}
          className="flex-[0.7]"
        >
          <div className="Body1-14BD text-white">{completeText}</div>
        </DSButton>
      </div>
    </>
  )
}

export default WhisperRecognition
